export default __webpack_public_path__ + "img/cwNjMqUr.eb8cb5ad.svg";